var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useRef } from 'react';
import { useFormQuery } from '@formily/react-schema-renderer';
import { defaults } from '@formily/shared';
export var useFormTableQuery = function (service, middlewares, defaultProps) {
    if (defaultProps === void 0) { defaultProps = {}; }
    var ref = useRef({});
    var _a = useState(defaults({
        current: 1,
        total: 0,
        pageSize: 20
    }, defaultProps.pagination)), pagination = _a[0], setPagination = _a[1];
    var _b = useState(defaultProps.sorter), sorter = _b[0], setSorter = _b[1];
    var _c = useState(defaultProps.filters), filters = _c[0], setFilters = _c[1];
    var _d = useFormQuery(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, service({
                    values: values,
                    pagination: ref.current.pagination,
                    sorter: ref.current.sorter,
                    filters: ref.current.filters
                })];
        });
    }); }, middlewares, ref.current), effects = _d.effects, trigger = _d.trigger, onSubmit = _d.onSubmit, loading = _d.loading, response = _d.response;
    ref.current.trigger = trigger;
    ref.current.pagination = pagination;
    ref.current.sorter = sorter;
    ref.current.filters = filters;
    ref.current.setPagination = setPagination;
    ref.current.setSorter = setSorter;
    ref.current.setFilters = setFilters;
    return {
        setPagination: setPagination,
        setSorter: setSorter,
        setFilters: setFilters,
        trigger: trigger,
        form: {
            effects: effects,
            onSubmit: onSubmit
        },
        table: {
            loading: loading,
            dataSource: response.dataSource || [],
            pagination: __assign(__assign({}, pagination), { current: response.current || 1, pageSize: response.pageSize || 20, total: response.total || 0 }),
            onChange: function (pagination, filters, sorter) {
                var type = '';
                if (pagination) {
                    setPagination(pagination);
                    type = 'onPageQuery';
                }
                if (filters) {
                    setFilters(filters);
                    type = 'onFilterQuery';
                }
                if (sorter) {
                    setSorter(sorter);
                    type = 'onSorterQuery';
                }
                trigger(type);
            }
        }
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/hooks/useFormTableQuery.js
// module id = 4699
// module chunks = 0